import React from "react";
import { map } from 'lodash';
import SvgIcon from "../../../../../../common/components/svg-icon";

const WithData = ({ title, summary, handleEditClick, handleUpdateSummary, onChangeAddToReport, disabled, region }) => {
  return (
    <div className="middle -no-margin">
      <h3>{title}</h3>
      {
        region &&
        <div className="summary-settings">
          { region.settings }
        </div>
      }
      <div className="summary-topics">
        <ul>
          {
            map(summary.raw_data, (item) => (
              <li key={ item.name }>
                <b>{item.name}:</b>
                {' '}
                { item.long_summary }
              </li>
            ))
          }
        </ul>
      </div>
      <div className="buttons">
        <a className="link" onClick={ handleEditClick }>
          <SvgIcon name="pen" />
          Edit Summary
        </a>
        <a className="link" onClick={ handleUpdateSummary }>
          <SvgIcon name="refresh" />
          Update Summary
        </a>
        <div className="link">
          <input
            type="checkbox"
            id={ `cb-${summary.tag}` }
            checked={ summary.add_to_report || false }
            onChange={ () => { onChangeAddToReport(!summary.add_to_report);} }
            disabled={ disabled }
          />
          <label className="checkbox_label" htmlFor={ `cb-${summary.tag}` }>Add to Report</label>
        </div>
      </div>
    </div>
  );
};

export default WithData;
